let loadedArticles = 10;
let totalArticles = 0;
const articleCount = 10;

// --------------------------- Load News //
const loadNews = () => {
	const offset = loadedArticles;

	$('.load-more-btn').text('Loading');

	$.ajax({
		type: 'GET',
		url: '/ajax/blogs.php',
		data: { count: articleCount, offset },
		dataType: 'json',
	})
		.done(response => {
			if (!response.err) {
				// Get Handlebars template //
				const source = $('#article-template').html();
				const template = Handlebars.compile(source);

				totalArticles = parseInt(response.article_total);
				loadedArticles += Object.keys(response.data).length;

				// News Page Articles //
				$('#blogs').append(
					template({
						articles: response.data,
					})
				);

				if (loadedArticles >= totalArticles) {
					$('.load-more-btn').hide();
				}

				$('.load-more-btn').text('Load More');
			}
			else {
				$('.articles-container .load-more .load-more-btn').html(response.msg).prop('disabled', 'disabled');
			}
		})
		.fail(error => {
			console.error('error', error);
		});
};

$('body').on('click', '.load-more-btn', () => {
	loadNews();
	return false;
});

Handlebars.registerHelper('convertToHtml', data => {
	const txt = document.createElement('textarea');
	txt.innerHTML = data;
	return txt.value;
});
